import {
  collection,
  get,
  all,
  query,
  where,
  add,
  set,
  update
} from "typesaurus"
import { GroupType, GeoState } from "../types"

export type TestScore = {
  percentage?: number
  possible?: number
  raw?: number
  scale?: number
  questionsAttempted?: number
  totalAnswered?: number
  studentCount?: number
  complete?: boolean
  ebrw?: number
  math?: number
  scaleScoreCounters?: {
    [key: string]: {
      [key: string]: number
    }
  }
}

export type bySubtestScoreType = {
  percentage?: number
  possible?: number
  raw?: number
  scale?: number
  studentCount?: number
  complete?: boolean
  scaleScoreCounters?: { [key: string]: number }
}

export type ItemScoresType = {
  index: number
  possible: number
  raw: number
  itemId?: string
  subtestId?: string
  prefix?: string
}

export type NodeScoresType = {
  items: string[]
  percentage: number
  possible: number
  raw: number
}

export type byItemType = {
  [key: string]: ItemScoresType
}

export type byNodeType = {
  [key: string]: NodeScoresType
}

export type scoringType = {
  byItem: {
    [key: string]: byItemType
  }
  byNode: {
    [key: string]: byNodeType
  }
  bySubtest: {
    [key: string]: bySubtestScoreType
  }
  byTest: TestScore
}

export interface GroupUA {
  id: string
  assessmentId: string
  groupId: string
  district: string
  school?: string
  class?: string
  teacher?: string
  groupType: GroupType
  lastUpdated: number
  state: GeoState
  year: string | number
  updated: boolean
  scoring?: scoringType
  answersByItem?: {
    [key: string]: any
  }
  thresholdFilterData?: {
    [key: string]: any
  }
}

const collection_ref = collection<GroupUA>("groupUAs")

export const getGroupUAsById = (id: string) => {
  return get(collection_ref, id)
}

export const getGroupUAsWhereId = (id: string) => {
  return query(collection_ref, [where("id", "==", id)])
}

export interface StaarThreshold {
  type: string
  is_visible: boolean
  custom_value?: number
}

export interface StaarThresholdSettingsData {
  [key: string]: StaarThreshold
}
